"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EAuthenticateByTokenStatus = void 0;
let EAuthenticateByTokenStatus = exports.EAuthenticateByTokenStatus = /*#__PURE__*/function (EAuthenticateByTokenStatus) {
  EAuthenticateByTokenStatus["Initial"] = "initial";
  EAuthenticateByTokenStatus["Loading"] = "loading";
  EAuthenticateByTokenStatus["Suspended"] = "suspended";
  EAuthenticateByTokenStatus["Succeed"] = "succeed";
  EAuthenticateByTokenStatus["Failed"] = "failed";
  return EAuthenticateByTokenStatus;
}({});